<template>
  <div class="app-container">
    <headerComponent
      :tab="tab"
      :title="'前台书城'"
      :slideData="slideData"
      @headerTabBack="headerTabBack"
    />
    <transition name="fade-transform" mode="out-in">
      <component :is="tab"></component>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import headerComponent from "@/components/tabHeader";
import channel from "./components/channel";
import slider from "./components/slider";
import frame from "./components/frame";

export default {
  components: {
    headerComponent,
    channel,
    slider,
    frame
  },
  computed: {
    slideData() {
      const slideData = [
        {
          name: this.$t("content.store.channel"),
          component: "channel"
        },
        {
          name: this.$t("content.store.banner"),
          component: "slider"
        },
        {
          name: this.$t("content.store.frame"),
          component: "frame"
        }
      ];
      return slideData;
    }
  },
  data() {
    return {
      tab: this.$route.query.name || "channel"
    };
  },
  methods: {
    headerTabBack(item) {
      this.tab = item.component;
      this.$router.push({ path: "bookstore", query: { name: item.component } });
    }
  }
};
</script>

<style lang="scss" scoped></style>
